<template>
    <div class="footer-container">
        <div class="footer-flex">
            <div class="footer-links">
                <div class="head_text">
                    QUICK LINKS
                </div>
                <div class="links-grid">
                    <div class="links-group">
                        <span @click="$router.push({ name: 'home', replace: true })" href="" class="link">Home</span><br>
                        <span @click="$router.push({ path: '/#pricing', replace: true })" href="" class="link">Pricing</span><br>
                        <span @click="$router.push({ name: 'partners', replace: true })" href="" class="link">Team</span><br>
                        <span @click="$router.push({ name: 'contact', replace: true })" href="" class="link">Contact</span>
                    </div>
                    <div class="links-group">
                        <span @click="$router.push({ name: 'About_E', replace: true })" href="" class="link">Relevant Papers</span><br>
                        <span @click="$router.push({ name: 'instructions', replace: true })" href="" class="link">Instructions</span><br>
                        <span href="" class="link">FAQs</span><br>
                        <span @click="$router.push({ name: 'About_D', replace: true })" href="" class="link">Relevant Projects</span>
                    </div>
                </div>
            </div>
            <div class="footer-contact">
                <div class="head_text">
                    CONTACT INFO
                </div>
                <div class="contact-block">
                    Email:
                    nutrisense@nutrisense.online
                    <br>
                    Phone:
                    <span class="phone">+30 697 387 6604</span>,
                    <span class="phone">+30 694 589 3830</span>,
                    <span class="phone">+30 698 286 3724</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>

<style scoped>
/* Spacing is declared explicitly rather than via Vuetify's mt-/mb- helpers so
   the block keeps its rhythm without depending on grid gutters. */
.footer-container {
    min-height: 350px;
    margin-top: 56px;
    background: #000;
    color: #fff;
    font-size: 18px;
    line-height: 1.5;
}
.head_text {
    color: #71a253;
    font-weight: bold;
    margin-top: 40px;
    margin-bottom: 24px;
}
/* Three flex tracks: a left inset (replacing the old 50%-wide centred
   container, so QUICK LINKS keeps its original position), the links block at
   its natural width, and CONTACT INFO taking all the width that is left. */
.footer-flex {
    display: flex;
    align-items: flex-start;
    gap: 40px;
    padding-left: 25%;
    padding-right: 5%;
}
.footer-links {
    flex: 0 0 auto;
}
.footer-contact {
    flex: 1 1 auto;
    min-width: 0;
}
.links-grid {
    display: flex;
    gap: 40px;
}
.links-group {
    flex: 0 0 auto;
    white-space: nowrap;
}
.link {
    text-decoration: none;
    color: #fff;
}
span {
    cursor: pointer;
}
/* nowrap so a number is never split across two lines; the list as a whole
   still wraps between numbers when the column runs out of room */
.phone {
    color: #c5c5c5;
    cursor: unset;
    white-space: nowrap;
}
.contact-block {
    margin-top: 16px;
}

/* on laptop widths a 25% inset is both narrower than the page content and
   tight enough to wrap the phone list, so pull it in */
@media (max-width: 1264px) {
    .footer-flex {
        padding-left: 10%;
        gap: 32px;
    }
}

/* below the md breakpoint the inset collapses and the two blocks stack */
@media (max-width: 960px) {
    .footer-flex {
        flex-wrap: wrap;
        gap: 24px;
        padding-left: 5%;
        padding-right: 5%;
    }
    .footer-links,
    .footer-contact {
        flex: 1 1 100%;
    }
    .footer-container {
        font-size: 16px;
    }
}

@media (max-width: 600px) {
    .footer-container {
        font-size: 14px;
        min-height: auto;
        padding-bottom: 30px;
    }
    .links-grid {
        gap: 24px;
    }
}
</style>
